import { render } from "./ReactivationComplete.vue?vue&type=template&id=38dc69b1"
import script from "./ReactivationComplete.vue?vue&type=script&lang=js"
export * from "./ReactivationComplete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__